<h2 class="default-dialog-header" mat-dialog-title>
	<span fxFlex>Set Password</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer">close</mat-icon>
	</span>
</h2>

<mat-divider></mat-divider>

<app-default-progress-bar
	*ngIf="utilService.isNullOrUndefined(resetPasswordForm) || !isFormInitialized"
></app-default-progress-bar>
<form
	(keydown.enter)="$event.stopPropagation()"
	*ngIf="!utilService.isNullOrUndefined(resetPasswordForm) && isFormInitialized"
	[formGroup]="resetPasswordForm"
>
	<mat-dialog-content class="default-dialog-content">
		<div class="m-t-2" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2rem">
			<div fxFlex>
				<mat-form-field style="width: 100%">
					<app-password-input
						formControlName="password"
						placeholder="Password"
						required
					></app-password-input>
				</mat-form-field>
			</div>
		</div>
		<p
			*ngIf="
				resetPasswordForm.controls.password.touched &&
				resetPasswordForm.get('password').value.length < 8
			"
			class="m-t-0 danger-text"
		>
			Please enter at least 8 characters.
		</p>

		<p
			*ngIf="
				resetPasswordForm.controls.password.touched &&
				resetPasswordForm.get('password').value.length >= 8 &&
				resetPasswordForm.get('password').invalid
			"
			class="m-t-0 danger-text"
		>
			Passwords must be at least 8 characters and contain at least 1 number, 1 lowercase letter, and
			one uppercase letter.
		</p>

		<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2rem">
			<div fxFlex>
				<mat-form-field style="width: 100%">
					<app-password-input
						formControlName="confirmPassword"
						placeholder="Confirm Password"
						required
					></app-password-input>
				</mat-form-field>
			</div>
		</div>

		<p
			*ngIf="
				resetPasswordForm.controls.confirmPassword.touched &&
				resetPasswordForm.hasError('notSame') &&
				resetPasswordForm.get('password').valid
			"
			class="m-t-0 danger-text"
		>
			Please enter the same password as above
		</p>
	</mat-dialog-content>
	<mat-divider></mat-divider>

	<mat-dialog-actions class="default-dialog-action">
		<div fxFlex="100" fxLayoutAlign="end end" fxLayoutGap="1rem">
			<button
				(click)="resetPassword()"
				*ngIf="!isRequestInProgress"
				[disabled]="!resetPasswordForm.valid"
				color="primary"
				mat-raised-button
			>
				Update
			</button>
			<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
		</div>
	</mat-dialog-actions>
</form>
